import { Locale, type LocalizedString } from "../Locale.js";

export const blogPathMap = {
	[Locale.cs]: "blog",
	[Locale.en]: "blog",
	[Locale.pl]: "blog",
	[Locale.sk]: "blog",
} satisfies LocalizedString;
